// app/question/test.js

(function () {
    "use strict";
    var controllerId = "asl_test";
    angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$filter", "$location", "common", "bootstrap.dialog", "$routeParams", "$q", "$uibModal", "datacontext", "sectionMenu", "filterFilter", asl_testFn]);

    function asl_testFn($rootScope, $scope, $filter, $location, common, bDialog, $routeParams, $q, $uibModal, datacontext, sectionMenu, filterFilter) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = "Test";
        vm.view = "list";       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "test"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.readonly = true;

        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ["autore", "difficolta'", "docente", "materia", "titolo", "ultima modifica"];
        vm.ordine = vm.list.ordine[4];

        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.questions = [];
        vm.getRecord = getRecord;
        vm.getListQuestions = getListQuestions;

        //Filtro
        vm.filter = {};
        vm.filter.ricerca = "";
        vm.filter.stato = 0;
        vm.filter.testAllievi = -1;
        vm.fRicerca = "";
        vm.fStato = 0;
        vm.fTestAllievi = -1;

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.testId != null) {
                            setView("detail");
                            getRecord($routeParams.testId, 0);
                        }
                    });            
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {            
            if (view == 'list') {                
                cerca();
            }
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.ricerca = vm.fRicerca == null ? 0 : vm.fRicerca;
            vm.filter.testAllievi = vm.fTestAllievi == null ? -1 : vm.fTestAllievi;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {            
            return datacontext.asl_test_countAll(vm.filter.ricerca, vm.filter.stato, vm.filter.testAllievi)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {            
            if (vm.loading === true) return;
            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.asl_test_getAll(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.stato, vm.filter.testAllievi, vm.ordine)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;                    
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.test_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                vm.record.status = $filter("teststatus")(data.status);

                //Azzera liste
                vm.list.questions = [];                
                getListQuestions(id);                
                setView("detail");
            });
        }

        //List Methods
        function getListQuestions(id) {
            if (!id) return;
            return datacontext.questionTest_getAllByTest(id, "sequence").then(function (data) {
                return vm.list.questions = data;
            });
        }
    }
})();
